export const getURLStringFromInputString = (str: string) => str.split(' ').join('-').toLowerCase() || ''

export const getKebabCaseURLFromInputString = (str: string) =>
  str
    .trim()
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase() || ''

export const getStringFromSlugInput = (str: string) => str.split('-').join(' ').toLowerCase() || ''
